import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { Portal } from "@vfit/shared/components";
import { Modal } from "@vfit/shared/atoms";
import { OverlayGlobalStyle, WrapperOverrideStyle } from "./vfModal.style";
var VfModal = function(param) {
    var isOpen = param.isOpen, handleClose = param.handleClose, height = param.height, children = param.children, tabletMode = param.tabletMode, customFooter = param.customFooter, wrapperId = param.wrapperId, isDisabledClose = param.isDisabledClose;
    useEffect(function() {
        var closeOnEscapeKey = function(e) {
            return e.key === "Escape" ? handleClose === null || handleClose === void 0 ? void 0 : handleClose() : null;
        };
        document.body.addEventListener("keydown", closeOnEscapeKey);
        return function() {
            document.body.removeEventListener("keydown", closeOnEscapeKey);
        };
    }, [
        handleClose
    ]);
    return isOpen ? /*#__PURE__*/ _jsx(Portal, {
        wrapperId: "coverage-tool",
        children: /*#__PURE__*/ _jsxs(WrapperOverrideStyle, {
            wrapperId: wrapperId,
            children: [
                /*#__PURE__*/ _jsx(OverlayGlobalStyle, {}),
                /*#__PURE__*/ _jsxs(Modal, {
                    customId: wrapperId,
                    withBorderRadius: true,
                    show: isOpen,
                    onCloseModal: handleClose,
                    isDisabledClose: isDisabledClose,
                    height: height,
                    tabletMode: tabletMode,
                    children: [
                        children,
                        customFooter && customFooter()
                    ]
                })
            ]
        })
    }) : null;
};
export default VfModal;
